export default [{
  name: 'password',
  path: '/password',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/password/Password.vue').default
}]
